/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const UpdateUserDjSoftwareDtoDjSoftwareEnum = {
    Serato: 'serato',
    Virtualdj: 'virtualdj',
    Rekordbox: 'rekordbox',
    Other: 'other'
};
/**
 * Check if a given object implements the UpdateUserDjSoftwareDto interface.
 */
export function instanceOfUpdateUserDjSoftwareDto(value) {
    return true;
}
export function UpdateUserDjSoftwareDtoFromJSON(json) {
    return UpdateUserDjSoftwareDtoFromJSONTyped(json, false);
}
export function UpdateUserDjSoftwareDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'djSoftware': json['dj_software'] == null ? undefined : json['dj_software'],
    };
}
export function UpdateUserDjSoftwareDtoToJSON(json) {
    return UpdateUserDjSoftwareDtoToJSONTyped(json, false);
}
export function UpdateUserDjSoftwareDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'dj_software': value['djSoftware'],
    };
}
